const STORAGE_KEY = "zgai.console.theme.v1";

export type ThemeChoice = "system" | "light" | "dark";

const VALID_CHOICES: ThemeChoice[] = ["system", "light", "dark"];

/**
 * Spec §3.3 / §4.6: first visit follows the system preference; if the OS
 * preference cannot be read we fall back to light. Once the user picks an
 * explicit theme we persist the choice and never overwrite it on next visit.
 * "system" listens for prefers-color-scheme changes via matchMedia.
 */
export function readStoredTheme(): ThemeChoice {
  if (typeof localStorage === "undefined") return "system";
  const raw = localStorage.getItem(STORAGE_KEY);
  if (raw && (VALID_CHOICES as string[]).includes(raw)) {
    return raw as ThemeChoice;
  }
  return "system";
}

export function writeStoredTheme(choice: ThemeChoice): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(STORAGE_KEY, choice);
}

export function resolveSystemTheme(): "light" | "dark" {
  if (typeof window === "undefined" || !window.matchMedia) return "light";
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function effectiveTheme(choice: ThemeChoice): "light" | "dark" {
  return choice === "system" ? resolveSystemTheme() : choice;
}
